import React, { useContext, useRef } from 'react';
import styles from './ModalShell.module.css';
import ModalContext from 'config/context/modalContext';
import useTheme from 'config/useTheme';

const ModalShell = ({ children, closeOnOverlay }) => {
    const { dark } = useTheme();
    const { modal, handleModal } = useContext(ModalContext);
    const modalCardRef = useRef(null);

    const handleOutsideClick = (e) => {
        if (!modalCardRef.current.contains(e.target) && closeOnOverlay) {
            handleModal(false); // Zatvara modal ako je kliknuto van njega
        }
    };


    if (!modal) return null;
    return (
        <div onClick={handleOutsideClick} className={`${styles.component}  ${dark ? styles.dark : ""}`}>
            <div ref={modalCardRef} onClick={(e) => e.stopPropagation()} className={styles.modal_card}>
                {children}
            </div>
        </div>
    )
}

export default ModalShell;